import '../../../../node_modules/react-datepicker/dist/react-datepicker.css'

import { Component } from 'react'
import * as React from 'react'
import Datepicker from 'react-datepicker'
import { connect } from 'react-redux'
import dashboardApi from 'services/api/dashboard'

import CalendarsIcons from '../../img/calendar-icon.svg'
import ChargesIcon from '../../img/charges-icon.svg'
import CopyIcon from '../../img/copy-icon-white.svg'
import { copyToClipboard } from '../../utils/common'
import CustomInputComponent from '../pageComponents/inputTextComponent'
import ModalBody from '../pageComponents/modal/ModalBody'
import ModalComponent from '../pageComponents/modal/ModalComponent'
import ModalHeader from '../pageComponents/modal/ModalHeader'
import MultiSelect from '../pageComponents/multiselect'
import TogglePill from '../pageComponents/togglePill'
import LoadingIndicator from '../ReusableComponents/LoadingIndicator'

const mapStateToProps = state => ({
  paymentLink: state
})

const mapDispatchToProps = dispatch => ({
  onChange: () => {
    dispatch()
  }
})

class PaymentLink extends React.Component {
  constructor(props) {
    super(props)

    this.handleCreateLink = this.handleCreateLink.bind(this)
    this.handleShareLink = this.handleShareLink.bind(this)

    this.state = {
      fetching: false,
      showCalendar: false,
      showCharges: false,
      allowClientToSetAmount: true,
      checkInDate: null,
      checkOutDate: null,
      showSuccessStep: false,
      canChangePaymentAmount: true,
      chargesAcceptAll: false,
      chargesAcceptAllIncidentals: false,
      chargesAcceptFoodAndBeverage: false,
      chargesAcceptOther: '',
      chargesAcceptParking: false,
      chargesAcceptRoomAndTaxes: false,
      chargesAcceptEventCatering: false,
      authLink: '',
      authError: '',
      errors: [],
      shareData: {
        email: '',
        phone: '',
        shareWithEmail: false,
        shareWithText: false,
        shared: false
      }
    }
  }

  copyLink = e => {
    let textToInsert = this.state.authLink
    copyToClipboard(e, textToInsert)
  }

  render() {
    let errorFullName = this.state.errors.find(item => item.field === 'fullName')
    let errorEmail = this.state.errors.find(item => item.field === 'email')
    let errorPhone = this.state.errors.find(item => item.field === 'phone')
    if (!this.state.showSuccessStep) {
      return (
        <div>
          {this.state.authError && (
            <div className="paymentLink-error">
              <i className="error-icon"></i>
              {this.state.authError}
            </div>
          )}
          <AuthCreateLinkStep
            handleTransactions={this.props.handleTransactions}
            handleChangeCheckbox={this.handleChangeCheckbox}
            handleDateSelect={this.handleDateSelect}
            handleCreateLink={this.handleCreateLink}
            handlePhoneChange={this.handlePhoneChange}
            handleChange={this.handleChange}
            handleChangeAmount={this.handleChangeAmount}
            handleChangeAmountBlur={this.handleChangeAmountBlur}
            fetching={this.state.fetching}
            errorFullName={errorFullName}
            errorPhone={errorPhone}
            errorEmail={errorEmail}
            email={this.state.email}
            phone={this.state.phone}
            amountToPay={this.state.amount}
            allowClientToSetAmount={this.state.canChangePaymentAmount}
            showCharges={this.state.showCharges}
            renderChargesList={this.renderChargesList}
            checkInDate={this.state.checkInDate}
            checkOutDate={this.state.checkOutDate}
            roomAndTaxes={this.state.chargesAcceptRoomAndTaxes}
            allIncidentals={this.state.chargesAcceptAllIncidentals}
            foodAndBeverage={this.state.chargesAcceptFoodAndBeverage}
            parking={this.state.chargesAcceptParking}
            eventCharges={this.state.chargesAcceptEventCatering}
            showChargeListComponent={this.showChargeListComponent}
            showCalendar={this.state.showCalendar}
            showCalendarsComponent={this.showCalendarsComponent}
          />
        </div>
      )
    } else {
      return (
        <AuthLinkCreatedStep
          copyLink={this.copyLink}
          authLink={this.state.authLink}
          fullName={this.state.fullName}
          amount={this.state.amount}
          email={this.state.email}
          phone={this.state.phone}
          shareData={this.state.shareData}
          handleShareInputChange={this.handleShareInputChange}
          handleShareInputPhoneChange={this.handleShareInputPhoneChange}
          handleShareCheckboxChange={this.handleShareCheckboxChange}
          handleShareLink={this.handleShareLink}
          handleTransactions={this.props.handleTransactions}
        />
      )
    }
  }

  async handleCreateLink() {
    this.setState({
      fetching: true
    })
    let {
      email,
      fullName,
      phone,
      checkInDate,
      checkOutDate,
      amount,
      chargesAcceptAll,
      chargesAcceptAllIncidentals,
      chargesAcceptFoodAndBeverage,
      chargesAcceptParking,
      chargesAcceptRoomAndTaxes,
      canChangePaymentAmount,
      chargesAcceptEventCatering,
      chargesAcceptOther,
      requestDescription
    } = this.state

    const postData = {
      deliverToName: fullName,
      deliverToEmail: email,
      deliverToPhone: phone ? phone.replace(/\D/g, '') : '',
      isInvoice: false,
      requestDescription,
      checkInDate: checkInDate ? checkInDate.toJSON() : '',
      checkOutDate: checkOutDate ? checkOutDate.toJSON() : '',
      paymentAmount: amount ? amount.replace(/\$/g, '') : '',
      canChangePaymentAmount: canChangePaymentAmount,
      chargesAcceptAll,
      chargesAcceptAllIncidentals,
      chargesAcceptFoodAndBeverage,
      chargesAcceptParking,
      chargesAcceptRoomAndTaxes,
      chargesAcceptEventCatering,
      chargesAcceptOther,
      isRecurringPayment: false
    }

    if (chargesAcceptEventCatering) {
      postData.checkOutDate = postData.checkInDate
    }

    let response = await dashboardApi.getAuthLink(postData)
    let regexId = /\?id(.+)/g
    if (response.isSuccess) {
      this.setState({
        fetching: false,
        fullName: response.result.senderFullName,
        email: response.result.clientEmail,
        phone: response.result.clientPhoneNumber,
        amount: response.result.paymentAmount,
        authLink: response.result.uniqueShortLink,
        invoiceId: regexId.exec(response.result.uniqueShortLink)[1],
        showSuccessStep: true
      })

      let shareData = {}

      if (response.result.clientPhoneNumber) {
        shareData.phone = response.result.clientPhoneNumber
        shareData.shareWithText = true
      }

      if (response.result.clientEmail) {
        shareData.email = response.result.clientEmail
        shareData.shareWithEmail = true
      }

      this.setState({ shareData })
    }
    if (!response.isSuccess) {
      this.setState({
        fetching: false,
        authError: response.message
      })
    }
  }

  handleChange = event => {
    let value
    if (event.target.value === 'true') {
      value = true
    } else if (event.target.value === 'false') {
      value = false
    } else {
      value = event.target.value
    }
    this.setState({
      [event.target.name]: value
    })
  }

  handlePhoneChange = e => {
    this.setState({
      phone: e.target.value
    })
  }

  handleChangeAmount = event => {
    if (event.target.value.replace(/\$/g, '') === '') {
      this.setState({
        canChangePaymentAmount: true
      })
    }
    this.setState({
      amount: `$${event.target.value.replace(/[a-zA-Z$]/g, '')}`
    })
  }
  handleChangeAmountBlur = event => {
    let value = event.target.value.replace(/\$/g, '')
    if (value !== '') {
      this.setState({
        amount: `$${value}`
      })
    } else {
      this.setState({
        amount: ``
      })
    }
  }

  handleChangeCheckbox = event => {
    if (
      event.target.checked === true &&
      event.target.name === 'chargesAcceptAllIncidentals'
    ) {
      this.setState({
        chargesAcceptAll: true,
        chargesAcceptAllIncidentals: true,
        chargesAcceptFoodAndBeverage: true,
        chargesAcceptParking: true,
        chargesAcceptRoomAndTaxes: true,
        chargesAcceptEventCatering: true
      })
      return
    } else {
      this.setState({
        [event.target.name]: event.target.checked
      })
    }

    if (
      event.target.name === 'canChangePaymentAmount' &&
      this.state.amount.replace(/\$/g, '') === ''
    ) {
      this.setState({
        [event.target.name]: true
      })
      return
    }

    this.setState({
      [event.target.name]: event.target.checked
    })
  }

  handleDateSelect = (date, fieldName) => {
    const { checkOutDate } = this.state
    this.setState(
      {
        [fieldName]: date
      },
      this.filterDates
    )

    if (fieldName === 'checkInDate' && date > checkOutDate) {
      this.setState({
        checkOutDate: null
      })
    }
  }

  showChargeListComponent = () => {
    this.setState({
      showCharges: true
    })
  }

  showCalendarsComponent = () => {
    this.setState({
      showCalendar: true
    })
  }

  handleShareInputChange = (e, fieldName) => {
    let shareData = {
      ...this.state.shareData,
      [fieldName]: e.target.value
    }
    this.setState({ shareData })
  }

  handleShareInputPhoneChange = value => {
    let shareData = {
      ...this.state.shareData,
      phone: value
    }
    this.setState({ shareData })
  }

  handleShareCheckboxChange = (e, fieldName) => {
    let shareData = {
      ...this.state.shareData,
      [fieldName]: e.target.checked ? true : false
    }

    this.setState({ shareData })
  }

  async handleShareLink(e) {
    e.preventDefault()
    const { email, phone } = this.state.shareData

    let shareData = {
      ...this.state.shareData,
      sharing: true
    }

    this.setState({ shareData })

    if (shareData.shareWithText) {
      let postData = {
        phoneNumberToText: phone,
        encodedRequestIdentifier: this.state.invoiceId
      }
      dashboardApi.shareInvoiceViaSms(postData).then(() => {
        shareData.sharedWithText = true
        shareData.sharing = false
        this.setState({ shareData })
      })
    }

    if (shareData.shareWithEmail) {
      let postData = {
        emailAddressTo: email,
        encodedRequestIdentifier: this.state.invoiceId,
        message: ``
      }
      dashboardApi.shareInvoiceViaEmail(postData).then(() => {
        shareData.sharedWithEmail = true
        shareData.sharing = false
        this.setState({ shareData })
      })
    }
  }
}

const ChargesList = props => {
  const {
    roomAndTaxes,
    allIncidentals,
    foodAndBeverage,
    parking,
    eventCharges,
    handleChangeCheckbox,
    handleChange
  } = props
  return (
    <div className="multi-select-container">
      <MultiSelect
        name={'chargesAcceptRoomAndTaxes'}
        id={'roomAndTaxes'}
        textValue={'Room and taxes'}
        checked={roomAndTaxes}
        onChange={handleChangeCheckbox}
      />
      <MultiSelect
        name={'chargesAcceptAllIncidentals'}
        id={'allIncidentals'}
        textValue={'All charges'}
        checked={allIncidentals}
        onChange={handleChangeCheckbox}
      />
      <MultiSelect
        name={'chargesAcceptFoodAndBeverage'}
        id={'foodAndBeverage'}
        textValue={'Food and Beverage'}
        checked={foodAndBeverage}
        onChange={handleChangeCheckbox}
      />
      <MultiSelect
        name={'chargesAcceptParking'}
        id={'parking'}
        textValue={'Parking'}
        checked={parking}
        onChange={handleChangeCheckbox}
      />
      <MultiSelect
        name={'chargesAcceptEventCatering'}
        id={'chargesAcceptEventCatering'}
        textValue={'Event Charges'}
        checked={eventCharges}
        onChange={handleChangeCheckbox}
      />
      <input
        type="text"
        id="chargesAcceptOther"
        name="chargesAcceptOther"
        className="fake-multi-text"
        placeholder="Other (type here)"
        onChange={handleChange}
      />
    </div>
  )
}

class Calendars extends Component {
  render() {
    const { handleDateSelect, checkInDate, checkOutDate, isEvent } = this.props

    return (
      <div className="paymentLink__calendar__container">
        <div className="paymentLink__calendar--unit">
          <label>{isEvent ? 'Event date' : 'Check-in date'}</label>
          <Datepicker
            selected={checkInDate}
            onChange={date => {
              handleDateSelect(date, 'checkInDate')
            }}
          />
        </div>
        {!isEvent && (
          <div className="paymentLink__calendar--unit">
            <label>Check-out date</label>
            <Datepicker
              selected={checkOutDate}
              minDate={checkInDate}
              onChange={date => {
                handleDateSelect(date, 'checkOutDate')
              }}
            />
          </div>
        )}
      </div>
    )
  }
}

const sharedTextGenerator = shareData => {
  const { sharedWithEmail, sharedWithText, email, phone } = shareData
  return `Shared with ${sharedWithEmail ? email : ''} ${
    sharedWithEmail && sharedWithText ? 'and' : ''
  } ${sharedWithText ? phone : ''}`
}

const AuthLinkCreatedStep = props => {
  const { authLink, copyLink, fullName, amount, email, shareData, handleShareLink } =
    props
  return (
    <ModalComponent>
      <div className="paymentLink__modal-header">
        <ModalHeader
          whiteTheme={true}
          title="Authorization link created!"
          subTitle="Copy and share this link with your client and get paid."
        />
      </div>
      <ModalBody className="paymentLink__created">
        <div className="paymentLink__authLinkComponent">
          <div className="authorizationLink-holder">
            <span className="authorizationLink">{authLink}</span>
          </div>
          <button onClick={copyLink} className="paymentLink__copy-cta">
            <img src={CopyIcon} alt="copy" />
            <span>Copy</span>
          </button>
          <span className="copied">Copied!</span>
        </div>
        <div className="paymentLink__customer-details">
          <span className="paymentLink__customer-details__label">Client details</span>
          <div className="paymentLink__customer-details-left">
            <span className="customer-details__name">{fullName}</span>
            <span className="customer-details__email">{email}</span>
            <span className="customer-details__phone">{shareData.phone}</span>
          </div>
          <div className="paymentLink__customer-details-right">
            <p className="customer-details__price">
              {amount && `Authorization for $${amount}`}
            </p>
          </div>
        </div>
        <div>
          <div className="paymentLink__share">
            {shareData.sharedWithText || shareData.sharedWithEmail ? (
              <h3 className="shared">{sharedTextGenerator(shareData)}</h3>
            ) : (
              <div>
                <h3>Share Link</h3>
                <form onSubmit={handleShareLink}>
                  <div className="paymentLink__share__email">
                    <input
                      type="email"
                      value={shareData.email}
                      onChange={e => props.handleShareInputChange(e, 'email')}
                    />
                    <TogglePill
                      name={'shareLinkEmail'}
                      id={'shareLinkEmail'}
                      textValue={'Send email'}
                      checked={shareData.shareWithEmail}
                      onChange={e => props.handleShareCheckboxChange(e, 'shareWithEmail')}
                    />
                  </div>
                  <div className="paymentLink__share__phone">
                    <input
                      onChange={props.handleShareInputPhoneChange}
                      value={shareData.phone}
                      name="phone"
                    />
                    <TogglePill
                      name={'shareLinkText'}
                      id={'shareLinkText'}
                      textValue={'Send text'}
                      checked={shareData.shareWithText}
                      onChange={e => props.handleShareCheckboxChange(e, 'shareWithText')}
                    />
                  </div>
                  <button
                    disabled={
                      (!shareData.shareWithEmail && !shareData.shareWithText) ||
                      shareData.sharing
                    }
                  >
                    {shareData.sharing ? 'Sending...' : 'Share link'}
                  </button>
                </form>
              </div>
            )}
          </div>
        </div>
      </ModalBody>
    </ModalComponent>
  )
}

const AuthCreateLinkStep = props => {
  const {
    handleTransactions,
    fetching,
    errorFullName,
    handleChange,
    handlePhoneChange,
    phone,
    email,
    errorPhone,
    errorEmail,
    amountToPay,
    allowClientToSetAmount,
    handleChangeCheckbox,
    handleDateSelect,
    handleChangeAmount,
    showCharges,
    checkInDate,
    checkOutDate,
    showChargeListComponent,
    showCalendar,
    showCalendarsComponent,
    handleCreateLink,
    roomAndTaxes,
    allIncidentals,
    foodAndBeverage,
    parking,
    eventCharges,
    handleChangeAmountBlur
  } = props
  return (
    <ModalComponent>
      <div className="paymentLink__modal-header">
        <ModalHeader
          whiteTheme={true}
          title="Create authorization link"
          subTitle="Add your clients information to get started"
          handleTransactions={handleTransactions}
        />
      </div>
      <ModalBody>
        {fetching ? (
          <LoadingIndicator />
        ) : (
          <form onSubmit={handleCreateLink}>
            <CustomInputComponent
              id="fullName"
              name="fullName"
              setlabel="Full name"
              onChange={handleChange}
              haserror={errorFullName}
              errorMessage={errorFullName && errorFullName.message}
              autoFocus={true}
            />
            <div className="paymentLink__split-row">
              <div className="paymentLink__half-width">
                <CustomInputComponent
                  onChange={handlePhoneChange}
                  value={phone}
                  name="phone"
                  setlabel={'Phone number'}
                  floatinglabel={0}
                  required={'required'}
                  hasclearinput={0}
                />
                {errorPhone && (
                  <span className="error-phone-number">{errorPhone.message}</span>
                )}
              </div>
              <div className="paymentLink__separator">
                <span>OR</span>
              </div>
              <div className="paymentLink__half-width">
                <CustomInputComponent
                  id="email"
                  name="email"
                  setlabel="Email"
                  onChange={handleChange}
                  haserror={errorEmail}
                  value={email}
                  errorMessage={errorEmail && errorEmail.message}
                  isRequired={false}
                />
              </div>
            </div>
            <div className="paymentLink__charge-amount">
              <CustomInputComponent
                type="tel"
                id="amountToPay"
                name="amountToPay"
                setlabel="Amount to be paid (optional)"
                value={amountToPay}
                onChange={handleChangeAmount}
                onBlur={handleChangeAmountBlur}
                isRequired={false}
              />
              {amountToPay && (
                <div className="paymentLink__charge-amount--toggle">
                  <TogglePill
                    name={'canChangePaymentAmount'}
                    id={'allowClientToSetAmount'}
                    textValue={'Allow Client to set'}
                    checked={allowClientToSetAmount}
                    onChange={handleChangeCheckbox}
                  />
                </div>
              )}
            </div>
            <CustomInputComponent
              id="requestDescription"
              name="requestDescription"
              setlabel="Request for"
              onChange={handleChange}
              errorMessage={errorFullName && errorFullName.message}
              isRequired={false}
            />
            <div className="paymentLink__additional-info">
              <span>Additional information (optional)</span>
            </div>
            <div className="paymentLink__charges">
              {showCharges ? (
                <ChargesList
                  handleChangeCheckbox={handleChangeCheckbox}
                  handleChange={handleChange}
                  roomAndTaxes={roomAndTaxes}
                  allIncidentals={allIncidentals}
                  foodAndBeverage={foodAndBeverage}
                  parking={parking}
                  eventCharges={eventCharges}
                />
              ) : (
                <div
                  className="paymentLink__action-link"
                  onClick={showChargeListComponent}
                >
                  <img src={ChargesIcon} alt="charges" />
                  <label>Add charges to be placed</label>
                </div>
              )}
            </div>
            <div className="paymentLink__calendar">
              {showCalendar ? (
                <Calendars
                  isEvent={!roomAndTaxes}
                  handleDateSelect={handleDateSelect}
                  checkInDate={checkInDate}
                  checkOutDate={checkOutDate}
                />
              ) : (
                <div
                  className="paymentLink__action-link"
                  onClick={showCalendarsComponent}
                >
                  <img src={CalendarsIcons} alt="calendar" />
                  <label>
                    {!roomAndTaxes
                      ? 'Add event date'
                      : 'Add check-in and check-out dates'}
                  </label>
                </div>
              )}
            </div>
            <button className="paymentLink__save-cta">Continue</button>
          </form>
        )}
      </ModalBody>
    </ModalComponent>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentLink)
